import { injectMeApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/me.service';
import { baseApi } from '@service/base.api';

export const currentUserApi = injectMeApi(baseApi);

export const {
  useGetMeQuery,
  useGetMySupervisorQuery,
  useUpdatePasswordMutation,
  usePatchCurrentUserMutation,
} = currentUserApi;
